import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import moment from 'moment-timezone';

export type DateSectionGroups<T> = {
  today: T[];
  yesterday: T[];
  previous: T[];
};

/**
 * Groups fragments into today / yesterday / previous by `createdAt` calendar day
 * in the given timezone (typically the station zone). Order within each array is preserved.
 */
export function groupFragmentsByDateSection(
  fragments: FragmentListItemDto[],
  timeZone: string,
): DateSectionGroups<FragmentListItemDto> {
  const todayStart = moment().tz(timeZone).startOf('day');
  const yesterdayStart = todayStart.clone().subtract(1, 'day');

  const result: DateSectionGroups<FragmentListItemDto> = {
    today: [],
    yesterday: [],
    previous: [],
  };

  for (const fragment of fragments) {
    const dayStart = moment(fragment.createdAt).tz(timeZone).startOf('day');

    if (dayStart.isSame(todayStart)) {
      result.today.push(fragment);
    } else if (dayStart.isSame(yesterdayStart)) {
      result.yesterday.push(fragment);
    } else {
      result.previous.push(fragment);
    }
  }

  return result;
}
